(function () {
  'use strict';
  var mobile = window.matchMedia('(max-width: 749px)');
  var contextKey = 'ww:browse-context';
  // Legacy search links without a type must use the same product-only scope as our forms.
  if (document.querySelector('[data-product-search="true"]')) {
    var searchUrl = new URL(window.location.href);
    if (searchUrl.searchParams.get('type') !== 'product') {
      searchUrl.searchParams.set('type', 'product');
      searchUrl.searchParams.delete('page');
      window.location.replace(searchUrl.href);
      return;
    }
  }

  function enhanceFacets(scope) {
    scope.querySelectorAll('[data-facets]:not([data-facets-ready])').forEach(function (facets) {
      facets.dataset.facetsReady = 'true';
      var panel = facets.querySelector('[data-facets-panel]');
      var trigger = facets.querySelector('[data-facets-open]');
      var closer = facets.querySelector('[data-facets-close]');
      var backdrop = facets.querySelector('[data-facets-backdrop]');
      var form = facets.querySelector('[data-facets-form]');
      if (!panel || !trigger || !form) return;
      var opened = false;
      var inerted = [];
      var previousOverflow = '';

      function releaseModal() {
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
        backdrop.hidden = true;
        if (inerted.length) {
          inerted.forEach(function (item) { item.node.inert = item.value; });
          inerted = [];
          document.body.style.overflow = previousOverflow;
        }
      }
      function useModal() {
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        backdrop.hidden = false;
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        var branch = panel;
        while (branch && branch.parentElement) {
          Array.from(branch.parentElement.children).forEach(function (sibling) {
            if (sibling !== branch && sibling !== backdrop && sibling instanceof HTMLElement) {
              inerted.push({ node: sibling, value: sibling.inert });
              sibling.inert = true;
            }
          });
          if (branch.parentElement === document.body) break;
          branch = branch.parentElement;
        }
      }
      function setOpen(next, returnFocus) {
        releaseModal();
        opened = next;
        panel.hidden = !opened;
        closer.hidden = !opened;
        trigger.setAttribute('aria-expanded', String(opened));
        if (opened && mobile.matches) useModal();
        if (opened) closer.focus();
        else if (returnFocus) trigger.focus();
      }
      facets.classList.add('is-enhanced');
      setOpen(false, false);
      trigger.addEventListener('click', function (event) { event.preventDefault(); setOpen(!opened, true); });
      trigger.addEventListener('keydown', function (event) {
        if (event.key === ' ') { event.preventDefault(); setOpen(!opened, true); }
      });
      closer.addEventListener('click', function () { setOpen(false, true); });
      backdrop.addEventListener('click', function () { setOpen(false, true); });
      panel.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { event.preventDefault(); setOpen(false, true); return; }
        if (event.key !== 'Tab' || !mobile.matches) return;
        var focusable = Array.from(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),summary,[tabindex="0"]')).filter(function (node) { return node.getClientRects().length; });
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      mobile.addEventListener('change', function () {
        if (opened) { releaseModal(); if (mobile.matches) useModal(); }
      });
      window.addEventListener('pagehide', releaseModal);
      window.addEventListener('pageshow', function () {
        if (opened) setOpen(false, false);
        form.removeAttribute('aria-busy');
        form.querySelector('[type="submit"]').textContent = 'Show products';
      });
      form.querySelectorAll('.ww-facet__price').forEach(function (range) {
        var inputs = range.querySelectorAll('input');
        function validate() {
          inputs[1].setCustomValidity(inputs[0].value !== '' && inputs[1].value !== '' && Number(inputs[0].value) > Number(inputs[1].value) ? 'Maximum price must be greater than or equal to minimum price.' : '');
        }
        inputs.forEach(function (input) { input.addEventListener('input', validate); });
      });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var next = new URL(form.action, window.location.origin);
        next.search = '';
        new FormData(form).forEach(function (value, name) { if (String(value).trim() !== '') next.searchParams.append(name, value); });
        var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview) next.searchParams.set('preview_theme_id', preview);
        form.setAttribute('aria-busy', 'true');
        var submit = form.querySelector('[type="submit"]');
        submit.textContent = 'Finding matches…';
        window.location.assign(next.href);
      });
    });
  }

  function preserveRefinementQuery(scope) {
    var query = new URLSearchParams(window.location.search);
    scope.querySelectorAll('[data-preserve-filters] a[href]').forEach(function (link) {
      var next = new URL(link.href, window.location.origin);
      if (next.origin !== window.location.origin) return;
      query.forEach(function (value, name) {
        if (name.indexOf('filter.') === 0 || name === 'sort_by' || name === 'preview_theme_id') next.searchParams.append(name, value);
      });
      link.href = next.pathname + next.search;
    });
    scope.querySelectorAll('[data-clear-facets]').forEach(function (link) {
      var next = new URL(link.href, window.location.origin);
      ['sort_by', 'preview_theme_id'].forEach(function (name) { if (query.has(name)) next.searchParams.set(name, query.get(name)); });
      link.href = next.pathname + next.search;
    });
  }

  function rememberBrowse(event) {
    var link = event.target.closest('[data-results-context] [data-ww-product-link]');
    if (!link) return;
    var destination = new URL(link.href, window.location.origin);
    if (destination.origin !== window.location.origin || !destination.pathname.includes('/products/')) return;
    var source = link.closest('[data-results-context]');
    try {
      sessionStorage.setItem(contextKey, JSON.stringify({ url: window.location.pathname + window.location.search, title: source.dataset.resultsTitle || 'Your results', scrollY: window.scrollY, productUrl: destination.pathname, timestamp: Date.now() }));
    } catch (error) { /* Browsing works when storage is unavailable. */ }
  }
  function restoreBrowse() {
    if (!document.querySelector('[data-results-context]')) return;
    try {
      var context = JSON.parse(sessionStorage.getItem(contextKey) || 'null');
      if (!context || Date.now() - context.timestamp > 3600000 || context.url !== window.location.pathname + window.location.search || !Number.isFinite(context.scrollY) || context.scrollY < 0) return;
      var navigation = performance.getEntriesByType('navigation')[0];
      var referrer = document.referrer ? new URL(document.referrer) : null;
      var returning = navigation && navigation.type === 'back_forward' || referrer && referrer.origin === window.location.origin && referrer.pathname.includes('/products/');
      if (returning) requestAnimationFrame(function () { window.scrollTo({ top: context.scrollY, behavior: 'instant' }); });
    } catch (error) { /* Native browser restoration remains available. */ }
  }
  enhanceFacets(document);
  preserveRefinementQuery(document);
  document.addEventListener('click', rememberBrowse);
  document.addEventListener('auxclick', rememberBrowse);
  window.addEventListener('pageshow', restoreBrowse);
  document.addEventListener('shopify:section:load', function (event) { enhanceFacets(event.target); preserveRefinementQuery(event.target); });
})();
